import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    action: String,
    params: Object,
    requestId: String
  }

  connect() {
    console.log("[CartCommand] Received command:", this.actionValue, this.paramsValue);
    
    // Send message to parent window (ai-mode.js)
    window.parent.postMessage({
      type: 'ai_mode_cart_command',
      action: this.actionValue,
      params: this.paramsValue,
      requestId: this.requestIdValue
    }, '*');
    
    // Remove the element after processing to avoid re-processing if DOM is cached/restored
    this.element.remove();
  }
}
